import React, { Component } from 'react';
import Header from '../../components/Header';
import SelectProduct from '../../components/Models/SelectProduct';
import { onGoBack } from '../../common/globals';
import {
  getProductMaster,
  getTableCaseByCaseId,
  updateTableCaseByPrimaryId,
  updateTableWiseCaseByCaseId
} from '../../utils/db';
import withGoBack from '../../common/withGoBack';
import withTableName from '../../common/withTableName';
import withOnline from '../../common/withOnline';
import withNotify from '../../common/withNotify';
import withLoader from '../../common/withLoader';
import Bugsnag from '../../helpers/bugsnag';
import ACMSelectedProduct from '../../components/Models/ACMSelectedProduct';

class AcmSelect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedProduct: {},
      selectProductDesc: '',
      searchProduct: '',
      productMaster: [],
      productMasterSearchResult: [],
      searchProductId: '',
      searchProductDesc: '',
      filterData: [],
      caseRes: {},
      selectedProductCount: []
    };
    this.acmSelectedProduct = null;
    this.selectProductModal = null;
  }

  componentDidMount() {
    try {
      this.acmSelectedProduct = new window.bootstrap.Modal(window.$('#acmSelectedProduct'), {});
      this.selectProductModal = new window.bootstrap.Modal(window.$('#selectProductModal'), {});
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onProductSelect = (product) => {
    try {
      const { selectedProductCount } = this.state;
      if (selectedProductCount !== null) {
        if (selectedProductCount.length >= 10) {
          this.acmSelectedProduct.show();
          return;
        }
      }
      this.selectProductModal.show();
      this.setState({ selectedProduct: product });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSave = async (data) => {
    try {
      const {
        online, setLoader, tableName
      } = this.props;
      const { caseRes, selectedProductCount } = this.state;
      if (selectedProductCount !== null) {
        if (selectedProductCount.length >= 10) {
          this.acmSelectedProduct.show();
          return;
        }
      }
      // const responseJson = {};
      let selectedValue = caseRes.ACMSelectedParts !== null ? caseRes.ACMSelectedParts : '';
      selectedValue += `${(caseRes.ACMSelectedParts === null) ? data.ProductNo : `;${data.ProductNo}`}`;
      caseRes.ACMSelectedParts = selectedValue;
      if (online) {
        /* await updateCase(caseRes);
        setLoader(false);
        responseJson = await listSingleCase(caseRes.CaseScheduleID); */
        updateTableWiseCaseByCaseId(caseRes.RepCaseNo, caseRes, tableName);
        this._selectedCount();
        this.selectProductModal.hide();
        /* const { message, status } = responseJson;
        if (status) {
          // const caseDetails = responseJson.data[0];
          // caseDetails.id = parseInt(id, 10);
          // caseDetails.Sync = 1;

        } else {
          notify({ type: 'error', message });
        } */
      } else {
        caseRes.Sync = 1;
        updateTableCaseByPrimaryId(caseRes.id, caseRes, tableName);
        setLoader(false);
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _selectedCount = () => {
    try {
      const { caseRes } = this.state;
      this.setState({
        selectedProductCount: caseRes.ACMSelectedParts !== null ? caseRes.ACMSelectedParts.split(';') : []
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSearchProducts = (value, key) => {
    try {
      this.setState({ [key]: value }, () => {
        this._onSearchProductsList();
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSearchProductsList = () => {
    try {
      const { productMasterSearchResult, searchProductId, searchProductDesc } = this.state;
      const searchProductIds = searchProductId.toUpperCase();
      const searchProductDescs = searchProductDesc.toUpperCase();
      const itemsUpdate = productMasterSearchResult.filter((item) => {
        const ProductNo
            = item.ProductNo !== null && item.ProductNo
              .includes(searchProductIds !== null && searchProductIds);
        const ProductDescription
            = item.ProductDescription !== null && item.ProductDescription
              .includes(searchProductDescs !== null && searchProductDescs);
        return ProductNo && ProductDescription;
      });
      this.setState({
        filterData: (searchProductId.length > 2 || searchProductDesc.length > 2) ? itemsUpdate : []
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  async UNSAFE_componentWillMount() {
    try {
      const { params: { id }, tableName } = this.props;
      const productMasterRes = await getProductMaster();
      const caseRes = await getTableCaseByCaseId(id, tableName);
      this.setState({
        productMaster: productMasterRes,
        productMasterSearchResult: productMasterRes,
        caseRes
      }, () => this._selectedCount());
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  render() {
    const { goBack } = this.props;
    const {
      searchProductId, searchProductDesc, filterData, selectedProduct, caseRes, selectedProductCount
    } = this.state;
    const productCount = selectedProductCount.filter((x) => x !== '');
    return (
      <div className="site-wrapper">
        <section className="sticky-top">
          <Header
            title="Select Products"
            goBack={() => onGoBack(goBack)}
          />
        </section>
        <section className="scan-section">
          <div className="container">
            <div className="top-block">
              <div className="row">
                <div className="col-12">
                  <p>
                    Selected Products: {productCount.length}
                  </p>
                </div>
              </div>
            </div>
            <div className="scan-list">
              <div className="form-group">
                <label htmlFor="searchProduct">Search Product #</label>
                <input
                  type="text" className="form-control"
                  placeholder="Search product..."
                  onChange={({ target: { value } }) => {
                    this._onSearchProducts(value, 'searchProductId');
                  }}
                  value={searchProductId}
                />
              </div>
              <div className="form-group">
                <label htmlFor="productDesc">Product Description</label>
                {/* <Select2
                  style={{ width: '100%', color: 'red' }}
                  className="form-select form-control"
                  data={productDesc.map(({ id, desc }) => ({ id, text: desc }))}
                  onChange={({ target: { value } }) => {
                    this.setState({ selectProductDesc: value });
                  }}
                  value={selectProductDesc}
                  options={{ placeholder: 'Product Description' }}
                /> */}

                <input
                  type="text" className="form-control"
                  placeholder="Product Description"
                  // onChange={(e) => this._onSearchProductDesc(e)}
                  onChange={({ target: { value } }) => {
                    this._onSearchProducts(value, 'searchProductDesc');
                  }}
                  value={searchProductDesc}
                />
              </div>
            </div>
            <div className="sets-list-blocks p-0">
              <div className="sets-block">
                <ul className="list-unstyled">
                  {
                    filterData && filterData.map((item, key) => (
                      <li key={key}>
                        <div
                          className="contents-wrap"
                          onClick={() => this._onProductSelect(item)}
                        >
                          <div className="row gx-2">
                            <div className="col-auto">
                              <div className="left-icon">
                                <i className="fas fa-plus theme-color cursor-pointer" />
                              </div>
                            </div>
                            <div className="col">
                              <p>{item.ProductNo}</p>
                              <p>{item.ProductDescription}</p>
                            </div>
                          </div>
                        </div>
                      </li>
                    ))
                  }
                </ul>
              </div>
            </div>
          </div>
        </section>
        <SelectProduct
          product={selectedProduct}
          onCancel={() => {
            this.setState({ selectedProduct: {} });
          }}
          onSave={this._onSave}
          caseRes={caseRes}
        />
        <ACMSelectedProduct />
      </div>
    );
  }
}

export default withTableName(withLoader(withNotify(withOnline(withGoBack(AcmSelect)))));
